module.exports = function ()
{
    this.organizationTaxonomy = {
        franchisors: [],
        franchisees: [],
        properties: [],
        propertyTaxonomies: []
    };
}